import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { LEGAL_UPDATE } from "@/config/legal";

// Rendu générique des pages juridiques
const LegalPage = ({ content, path }) => (
  <>
    <Seo title={`${content.title} | ASTROLOG`} description={content.seo} path={path} />
    {/* Modèle à faire relire par un conseil juridique avant publication. */}
    <section className="brand-dark noise relative py-14 sm:py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h1 className="font-heading text-3xl font-bold tracking-tight text-[#FAFAF7] sm:text-4xl">
            {content.title}
          </h1>
          <p className="mt-3 text-sm text-slate-400">{LEGAL_UPDATE}</p>
        </Reveal>
      </div>
    </section>
    <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16" data-testid="legal-content">
      <div className="space-y-10">
        {content.sections.map((s) => (
          <article key={s.h}>
            <h2 className="font-heading text-xl font-semibold text-foreground">{s.h}</h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
              {s.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  </>
);

export default LegalPage;
